export default "__VITE_ASSET__DRSzCM0h__"